export const lightered = 'pink'
export const primary = '#70d1f9'
export const primaryContrast = '#2c79a6'
export const primaryLightContrast = '#e6f8ff'
export const lightGrey = '#c1c1c1'
export const beige = '#F1ECE8'
export const libraryPaleOrange = 'RGBA(255, 165, 0, 0.4)'
